import * as React from "react";
import type { SVGProps } from "react";
const SvgTrendingDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M23 18v1a1 1 0 0 0 1-1zm-9.5-9.5.707-.707a1 1 0 0 0-1.414 0zm-5 5-.707.707a1 1 0 0 0 1.414 0zM1.707 5.293A1 1 0 0 0 .293 6.707zM17 17a1 1 0 1 0 0 2zm7-5a1 1 0 1 0-2 0zm-.293 5.293-9.5-9.5-1.414 1.414 9.5 9.5zm-10.914-9.5-5 5 1.414 1.414 5-5zm-3.586 5-7.5-7.5L.293 6.707l7.5 7.5zM17 19h6v-2h-6zm7-1v-6h-2v6z"
    />
  </svg>
);
export default SvgTrendingDown;
